import getSelectorDefinition from './get.js';
export default [getSelectorDefinition];
